import {
  columnsDataDevelopment,
  // columnsDataCheck,
  // columnsDataColumns,
  // columnsDataComplex,
} from "./variables/columnsData";
import tableDataDevelopment from "./variables/tableDataDevelopment.json";
// import tableDataCheck from "./variables/tableDataCheck.json";
// import tableDataColumns from "./variables/tableDataColumns.json";
// import tableDataComplex from "./variables/tableDataComplex.json";
import DevelopmentTable from "./components/DevelopmentTable";
// import ColumnsTable from "./components/ColumnsTable";
// import ComplexTable from "./components/ComplexTable";
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchFile } from '../../../redux/action/fetchAction'

const Tables = () => {
  const dispatch = useDispatch();
  // const uploadReducer = useSelector((state) => {
  //   return state.uploadReducer
  // });
  const [formData, setFormData] = useState({ cycleNo: "", fileType: "", date: "" });
  const [formDataState, setFormDataState] = useState([]);

  const handleSubmit = () => {
    console.log(formData);
    const form = new FormData();
    form.append('cycleNo', formData.cycleNo);
    form.append('fileType', formData.fileType);
    form.append('date', formData.date);
    form.append('file', formDataState[0]);

    // For multiple files upload
    // formDataState.forEach((file, index) => {
    //   form.append(`files[${index}]`, file);
    // });

    dispatch(fetchFile(form))

    // dispatch(uploadFile(formData))

  };

  return (
    <div className="w-full">
      <div className="mt-5 w-full">
        {/* <Filter /> */}
        <DevelopmentTable
          columnsData={columnsDataDevelopment}
          tableData={tableDataDevelopment}
          handleSubmit={handleSubmit}
          setFormData={setFormData}
          formData={formData}
          setFormDataState={setFormDataState}
          formDataState={formDataState}
        />
      </div>

    </div>
  );
};

export default Tables;
